<div class="row">
    <label class="col-md-2" [class.required]="required" [class.has-error]="required && isVide()">
        <span [translate]="libelle"></span>
    </label>
    <div class="col-md-10" [class.has-error]="required && isVide()">
        <editor
                *ngIf="isPret"
                [(ngModel)]="value"
                (ngModelChange)="onModelChange($event)"
                [init]="finalConfig">
        </editor>
    </div>
</div>